<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container" />
    <breadcrumb class="breadcrumb-container" />
    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          {{accountName}}<i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native.prevent="fullscreen">
            <span v-if="full">退出全屏</span><span v-else>全屏</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Modules/Breadcrumb'
import Hamburger from '@/components/Modules/Hamburger'
import screenfull from 'screenfull'
import Cookies from 'js-cookie'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ])
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    async logout () {
      await this.HttpRequest('/backend/account/logout')
      this.$store.dispatch('logOut').then(() => {
        location.reload()// In order to re-instantiate the vue-router object to avoid bugs
      })
    },
    fullscreen () {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        })
        return false
      }
      if (screenfull.isFullscreen) {
        this.full = false
      } else {
        this.full = true
      }
      screenfull.toggle()
    }
  },
  data: () => {
    return {
      avatar: require('../../../assets/face.png'),
      accountName: Cookies.get('username'),
      full: false
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 45px;
  line-height: 45px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 50px;
    height: 45px;
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus {
      outline: none;
    }
    .right-menu-item {
      display: inline-block;
      margin: 0 3px;
    }
    .avatar-container {
      height: 35px;
      margin-right: 20px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 1px;
        position: relative;
        .el-icon-caret-bottom {
          position: absolute;
          right: -15px;
          top: 15px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/components/Navbar.vue